import { render, staticRenderFns } from "./FormBuilderCell.vue?vue&type=template&id=6508185a&scoped=true&lang=pug&"
import script from "./FormBuilderCell.vue?vue&type=script&lang=js&"
export * from "./FormBuilderCell.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderCell.vue?vue&type=style&index=0&id=6508185a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508185a",
  null
  
)

/* custom blocks */
import block0 from "./FormBuilderCell.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports